import React from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Distribution from '@/components/pages/analytics/Distribution';
import clsx from 'clsx';

const GraphLayout = ({
  title,
  value,
  distribution,
  unit,
  ratio,
  hideValue,
  tooltipLabel,
  isDecimal,
  children,
  noValue,
  color = undefined,
  greenLineY,
  prevStat,
  data,
}) => {
  const classes = useStyles();

  const computedValue =
    noValue || hideValue || value == null ? (
      <span>&nbsp;</span>
    ) : (
      [isDecimal ? value?.toFixed(1) : value?.toFixed(0), unit].join(' ')
    );
  const difference = (data?.value ?? 0) - (prevStat?.value ?? 0);
  const formattedDifference = Number.isInteger(difference) ? difference.toString() : difference?.toFixed(1);
  const displayDifference = difference >= 0 ? `+${formattedDifference}` : formattedDifference;
  const percentDifference =
    prevStat?.value != null && data?.value != null && prevStat?.value !== 0 && data?.value !== 0
      ? ((data?.value - prevStat?.value) / prevStat?.value) * 100
      : prevStat?.value === 0 && data?.value === 0
        ? 0
        : prevStat?.value === 0
          ? 100
          : -100;

  const roundedPercentDifference = Math.abs(percentDifference).toFixed(1);
  const absolutePercentDifference = roundedPercentDifference + '%';
  const isAverageTime =
    data?.id === 'averageWaitingRoomTime' ||
    data?.id === 'averagePreOPTime' ||
    data?.id === 'averageORTime' ||
    data?.id === 'averagePACUTime' ||
    data?.id === 'averageCleaningTime' ||
    data?.id === 'averagePopiTime' ||
    data?.id === 'averagePostOpTime' ||
    data?.id === 'averageReadyForAnesthesiatoReadyForOR' ||
    data?.id === 'averageReadyForORtoPreOpExit' ||
    data?.id === 'averageClosingTime';

  return (
    <Box className={classes.root}>
      {!noValue && (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="baseline" flexWrap="wrap" style={{ gap: 8 }}>
            <Typography component="div" variant="h3" style={{ color }}>
              {computedValue}
            </Typography>
            <Typography
              className={clsx({
                [classes.good]: (percentDifference > 0 && !isAverageTime) || (percentDifference < 0 && isAverageTime),
                [classes.bad]: (percentDifference > 0 && isAverageTime) || (percentDifference < 0 && !isAverageTime),
              })}
            >
              {displayDifference} {` (${absolutePercentDifference}) `}{' '}
              {percentDifference > 0 ? '▲' : percentDifference === 0 ? '' : '▼'}
            </Typography>
          </Box>
        </Box>
      )}

      {children ? (
        children
      ) : (
        <Distribution
          color={color}
          distribution={distribution}
          unit={unit}
          label={title}
          ratio={ratio}
          tooltipLabel={tooltipLabel}
          greenLineY={greenLineY}
        />
      )}
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    flex: 1,
  },
  good: {
    color: theme.palette.success.main,
  },
  bad: {
    color: theme.palette.error.main,
  },
}));

export default GraphLayout;
